"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMaineRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _types = require("../../assets/types");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _Rule = require("../Rule");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'ME';

function getMaineRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Unmatured life insurance',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (10)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance Proceeds',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (11)',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (12)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiarytype = _lodash["default"].get(asset, 'assetJSON.tertiarytype');

      return this.canTakeMoreExemptions() && tertiarytype === _tertiaryTypes.SOCIAL_SECURITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(A); Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(C)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability or health benefits',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(A); Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(C); Me. Rev. Stat. Ann. tit. 24-A, § 2429',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.HEALTH_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Public assistance',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(A); Me. Rev. Stat. Ann. tit. 22, § 3766; Me. Rev. Stat. Ann. tit. 22, § 3180',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans benefits',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony and child support',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(D)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA Benefits',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (13)(F)',
    limitAggregateSingle: 15000,
    limitAggregateJoint: 30000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.IRA;
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime victims\' compensation',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (14)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful Death Recoveries',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (14)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.WRONGFUL_DEATH_AWARD];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (11)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Recovery',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (14)(D)',
    limitAggregateSingle: 12500,
    limitAggregateJoint: 25000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Lost Future Earnings',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (14)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Motor Vehicle (one)',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (2)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household goods, clothing, books, animals',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    // NOTE: The norm is that lawyers list all household goods together, not itemized even though that's the statute.
    // limitPerItem: 200,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.HOUSEHOLD, _subTypes.BOOK, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (4)',
    limitAggregateSingle: 750,
    limitAggregateJoint: 1500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Jewelry',
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.JEWELRY || subType === _subTypes.WEDDING_RINGS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (5)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Cooking Stove and Furnaces for Heat',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (6)(A),(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && [_tertiaryTypes.STOVE, _tertiaryTypes.FURNACE].includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (6)(C); Me. Rev. Stat. Ann. tit. 14, § 4422 (7)(A)',
    description: 'Food for Six Months. Fuel - 10 cords of wood, 5 tons of coal, or 1,000 gal. of heating oil',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FOOD_AND_FUEL;
    }
  }, {
    id: idCounter.increment(),
    description: 'Seeds, Fertilizer, and Feed (for 1 season)',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (7)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FARMING_SUPPLIES];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools and Equipment to Raise Food',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (7)(C)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FARMING_EQUIPMENT];
      return this.canTakeMoreExemptions() && type === _types.PERSONAL && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Farm Implement',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (8)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FARMING_EQUIPMENT];
      return this.canTakeMoreExemptions() && type === _types.AGRICULTURE && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Commercial Fishing Boat - 46-foot limit',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FISHING_BOAT];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Exempt property acquired within 90 days of filing',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4423',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.EXEMPT_PROPERTY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Group Health or Life proceeds',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 24-A, § 2430',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.LIFE_INSURANCE_PROCEEDS];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuity Proceeds - to $450 per month',
    type: stateCode,
    requiresReview: true,
    statuteName: 'Me. Rev. Stat. Ann. tit. 24-A, § 2431',
    limitAggregateSingle: 450,
    limitAggregateJoint: 900,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.ANNUITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Society Benefits',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 24-A, § 4118',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Death Benefits for Police, Fire or Emergency personnel',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 25, § 1612',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.INTEREST_FROM_DEATH_EMERGENCY_PERSONNEL;
    }
  }, {
    id: idCounter.increment(),
    description: 'Maintenance Under Rehabilitation Act',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 26, § 1411-H',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.REHABILITATION_ACT_MAINTENANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Legislator Retirement',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 3, § 703',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LEGISLATORS_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Military Clothes and Equipment',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 37-B, § 262',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.UNIFORMS || subType === _subTypes.MILITARY_EQUIPMENT);
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 39-A, § 106',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Judges Retirement',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 4, § 1203',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.JUDGES_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'State Employee Retirement',
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 5, § 17054',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.STATE_EMPLOYEES_PENSION;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard - Can apply unused homestead to $6,000, to be used for any of the following: jewelry, tools of trade, personal injury recoveries, or household goods & furnishings, clothing, appliances, books, animals, crops, and musical instruments (Me. Rev. Stat. Ann. tit. 14, § 4422(16)).',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Me. Rev. Stat. Ann. tit. 14, § 4422 (15)',
    limitAggregateSingle: 400,
    limitAggregateJoint: 800,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}